import auth from './auth'
import dashboard from './dashboard'
import inventory from './inventory'
import reception from './reception'
import dispatch from './dispatch'
import monitoring from './monitoring'
import orders from './orders'
import products from './products'
import documents from './documents'
import rules from './rules'
import tracking from './tracking'

export default {
  auth,
  dashboard,
  inventory,
  reception,
  dispatch,
  monitoring,
  orders,
  products,
  documents,
  rules,
  tracking
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/index.js